import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, onPrepareHeaders } from "@/redux/services/helpers";

/**
 * Shared RTK Query service for cross-module parameter endpoints.
 * Endpoints are injected from individual files in ./endpoints/.
 */
export const sharedService = createApi({
  reducerPath: "sharedService",
  tagTypes: [
    "States",
    "Countries",
    "Currencies",
    "TimeZones",
    "LoanPrograms",
    "LoanTypes",
    "LoanStatuses",
    "PropertyTypes",
    "PropertyUses",
    "ValuesBasedOn",
    "LenderCallLogStatuses",
    "Guarantees",
    "LenderOfferTypes",
    "RateTypes",
    "RateValueTypes",
    "PrepaymentPenaltyTypes",
    "MortgageIndexes",
    "NewGuarantees",
    "BankingTypes",
    "BrokerClosingReasons",
    "LenderClosingReasons",
    "CapWorksDeactivationReasons",
    "LoanDeletionReasons",
    "LoanWithdrawReasons",
  ],
  baseQuery: fetchBaseQuery({ baseUrl, prepareHeaders: onPrepareHeaders }),
  endpoints: () => ({}),
});
